import {
  manageAppsUpgradeSite,
  appMarketClickOnFreeTrialCta,
} from '@wix/bi-logger-app-market-data/v2';
import type { AppBadge } from '@wix/app-market-services';
import {
  useEssentials,
  getManageAppsUpgradeSite,
  getAppMarketClickOnFreeTrialCta,
} from '@wix/app-market-core';
import type { AppPageType } from '@wix/app-market-core-components-types';

export function useUpgradeButtonBiEvents({
  app,
  origin,
  showRedeemOfferButton,
  appPageType,
}: {
  app: {
    id: string;
    instanceId?: string;
    appBadges: AppBadge[];
  };
  origin: string;
  showRedeemOfferButton: boolean;
  appPageType?: AppPageType;
}) {
  const { biLogger } = useEssentials();

  return {
    reportUpgradeClick: () => {
      biLogger.report(
        manageAppsUpgradeSite(
          getManageAppsUpgradeSite({
            appId: app.id,
            appInstanceId: app.instanceId,
            upgrade_origin: origin,
            cta_type: showRedeemOfferButton ? 'redeem' : 'upgrade',
            appBadges: app.appBadges,
            appPageType,
          }),
        ),
      );
    },

    reportFreeTrialClick: () => {
      biLogger.report(
        appMarketClickOnFreeTrialCta(
          getAppMarketClickOnFreeTrialCta({
            appId: app.id,
            appInstanceId: app.instanceId,
            origin,
            appBadges: app.appBadges,
            appPageType,
          }),
        ),
      );
    },
  };
}
